module.exports = {
	"root": "findify-components-search--static-results",
	"column": "findify-components-search--static-results__column"
};